import { render, staticRenderFns } from "./resourceStoreManageList.vue?vue&type=template&id=2446b542&scoped=true"
import script from "./resourceStoreManageList.vue?vue&type=script&lang=js"
export * from "./resourceStoreManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreManageList.vue?vue&type=style&index=0&id=2446b542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446b542",
  null
  
)

export default component.exports